import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router } from '@angular/router';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

@Component({
    selector: 'app-dashboard',
    templateUrl: './users.component.html',
    providers: [ SharedService,PopupSegmentComponent]
    // styleUrls: ['./dashboard.component.scss']

})
export class UsersComponent implements OnInit {

objLoaderStatus: boolean = false;
data = [];
itemsTotalAdv =0;
page =1;
searchUserText = '';
enable = [];
enableFlag = false;
blockedFlag : boolean = false;
errormessage ='';
charFlag : boolean = false;
message = '';
searchmessage = '';

 column = "";
  numberColumn : number =0;
  order : string ="ASC";
  sortingOrder = [];
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private dialogService:DialogService,
    private router: Router) {
    
var i=0;
  for(i=0;i<3;i++){
    this.sortingOrder[i] = true;
  }
    
    }

    ngOnInit() {
           let body = document.getElementsByTagName('body')[0];
   body.classList.remove("zizbackground");
      body.classList.remove("overflow");
    var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 


let sidebar = <HTMLInputElement>(document.getElementsByClassName('sidebar'))[0];
sidebar.onclick = function(){
     var x= document.getElementById('id3');
       x.classList.remove("submenuActiveAdmin"); 

    }
this.localstorage.setStorage("country",'');

 this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
        var i=0;
    var token = this.localstorage.getStorage("token");
      this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/getAllUser?currentSize=25&sortColumn=firstName&sortOrder=ASC", null, token).subscribe((result) => {
      

    if(result.data){
      this.dataShowChange(result.data);
         this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
 this.loaderService.displayLoader(false);
  }
   else{
      this.loaderService.displayLoader(false);
    alert(result.meta.message);
  }
         });


    }

allUsers(){
   var i=0;
  for(i=0;i<3;i++){
    this.sortingOrder[i] = true;
  }
       this.column = "firstName";

  this.page = 1;
  var token = this.localstorage.getStorage("token");
      this.loaderService.displayLoader(true);
      this.itemsTotalAdv = 0;
      this.searchUserText = '';
         this.errormessage ="";
          this.searchmessage = "";
  this.shareService.CallDatawithToken("admin/getAllUser?currentSize=25&sortColumn=firstName&sortOrder=ASC", null, token).subscribe((result) => {
      

    if(result.data){
      this.dataShowChange(result.data);
         this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
 this.loaderService.displayLoader(false);
  }
   else{
      this.loaderService.displayLoader(false);
    alert(result.meta.message);
  }
         });
}

  deleteUser(id){
        var token = this.localstorage.getStorage("token");
        //this.id = id;
         this.showConfirmDelete(id);

  
   }

   nextUser(text,id,order,event){
     var order;
  if(text){
  this.column = text;
}
     if(id !== ''){
  this.numberColumn = id;
}

if(this.column == ""){
  this.column = "firstName";
}
 var i=0;
  for(i=0;i<6;i++){
 
    if(this.numberColumn != i ){
    this.sortingOrder[i] = true;
  }
  }
if(order){
  this.order = order;
}
  
  

  if(this.order == 'DESC'){
this.sortingOrder[this.numberColumn] = false;
  }
  else{
this.sortingOrder[this.numberColumn] = true;
  }
  this.itemsTotalAdv =0;
  this.data =[];
   var i=0;
   this.page = event;
    var token = this.localstorage.getStorage("token");
  this.errormessage ="";
  this.searchmessage = "";
      this.searchUserText = this.searchUserText.trim();

    if(this.blockedFlag == true){
      if((this.searchUserText == '' || this.searchUserText == undefined) ){
                    this.loaderService.displayLoader(true);
this.shareService.CallDatawithToken("admin/getAllBlockedUser?currentSize=25&currentPage="+event+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
    if(result.data){
     this.dataShowChange(result.data);
    
         this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
        this.loaderService.displayLoader(false);

   }
    else{
              this.loaderService.displayLoader(false);

    alert(result.meta.message);
  }
         });
      }
      else{
          if(this.searchUserText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
           if(this.column == "firstName"){
           this.column = "first_Name";
         }
         else if(this.column == ""){
this.column = "first_Name";
         }
           this.errormessage ="";
                     this.loaderService.displayLoader(true);
      this.shareService.CallDatawithToken("admin/searchBlockedUser?currentSize=25&q="+this.searchUserText+"&currentPage="+event+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
    if(result.data){
     if(result.data.length>0){
     this.dataShowChange(result.data);
    
         this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
          }else{
        this.searchmessage = "No records found";
      }
        this.loaderService.displayLoader(false);
    }
      });  
    }
      }
    }
    else if(this.searchUserText == '' || this.searchUserText == undefined){
                  this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/getAllUser?currentSize=25&currentPage="+event+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
    if(result.data){
     this.dataShowChange(result.data);
    
         this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
        this.loaderService.displayLoader(false);

   }
    else{
              this.loaderService.displayLoader(false);

    alert(result.meta.message);
  }
         });
    }
    else{
      if(this.searchUserText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
           if(this.column == "firstName"){
           this.column = "first_Name";
         }
           else if(this.column == ""){
this.column = "first_Name";
         }
         this.errormessage ="";
                     this.loaderService.displayLoader(true);
       this.shareService.CallDatawithToken("admin/searchUser?currentPage="+event+"&currentSize=25&q="+this.searchUserText+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
    if(result.data){
       if(result.data.length>0){
     this.dataShowChange(result.data);
    
         this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
          }else{
        this.searchmessage = "No records found";
      }
            this.loaderService.displayLoader(false);

  }
   else{
             this.loaderService.displayLoader(false);

    alert(result.meta.message);
  }
         }); 
    }
    }    
    return event;     
}

onChange(event,id){
        var token = this.localstorage.getStorage("token");
   if(event == true){
  
     this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/blockUser?userId="+id,{},token).subscribe((result) => {
  
    if(result.data && result.data.status == true){
       this.showblock()
;    
this.enable[id] = true;
event = true;
        this.loaderService.displayLoader(false);

}
    this.loaderService.displayLoader(false);
});
 
   }
   else{
    
     this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/unblockUser?userId="+id,{},token).subscribe((result) => {
  
    if(result.data && result.data.status == true){
this.showunblock();     
this.enable[id] = false;
event = false;
     this.loaderService.displayLoader(false);

}
    this.loaderService.displayLoader(false);
});
 
   }

  }
  
  getAllBlocked(){
     var i=0;
  for(i=0;i<3;i++){
    this.sortingOrder[i] = true;
  }
     var i=0;
     this.column = "firstName";
       this.data = [];
      this.itemsTotalAdv =0;
      this.blockedFlag = true;
            this.searchUserText = '';
  this.page = 1;
   this.errormessage ="";
          this.searchmessage = "";
    var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("admin/getAllBlockedUser?currentSize=25&sortColumn=firstName&sortOrder=ASC", null, token).subscribe((result) => {
    
    if(result.data){
    this.dataShowChange(result.data);
    
         this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
     this.loaderService.displayLoader(false);

  }
   else{
          this.loaderService.displayLoader(false);

    alert(result.meta.message);
  }
         });
  }
   
dataShowChange(data){
  var i=0
   for(i=0;i<data.length;i++){
      
    if(data[i].gender == 'F'){
data[i].gender = 'Female'
    }
    else if(data[i].gender == 'M'){
data[i].gender = 'Male'
    }
    else{
    data[i].gender = 'Others' ;
  }  
  
  if(data[i].accountStatus == 'BLOCKED'){
this.enable[data[i].userId]= true;
    }
    else{
this.enable[data[i].userId]= false;
    }
}


 this.data = data;

}


          showunblock() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'User Information', 
                message:'User Unblocked Successfully',
              data: [],
             showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    
                });
        }

          showblock() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'User Information', 
                message:'User Blocked Successfully',
              data: [],
             showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    
                });
        }

          showDelete() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'User Information', 
                message:'User Deleted Successfully',
              data: [],
             showcancel :false})
                .subscribe((isConfirmed)=>{
                    //We get dialog result
                    window.location.reload();
                });
        }

        showConfirmDelete(id){
                  var token = this.localstorage.getStorage("token");

let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'User Information', 
                message:'Are you sure you want to delete the User?',
              data: [],
             showcancel :true})
                .subscribe((isConfirmed)=>{
                  if(isConfirmed){
                   this.loaderService.displayLoader(true);
this.shareService.callApiWithToken("admin/deleteUser?userId="+id,{},token).subscribe((result) => {
    if(result.data.status == true){
      this.showDelete();
       // alert("Advertiser deleted successfully");
//window.location.reload();    }
    }
    this.loaderService.displayLoader(false);
});
                  }
                });

        }


}
   




// WEBPACK FOOTER //
// ./src/app/admin/layout/users/users.component.ts